import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState, useEffect } from 'react';
import {faEnvelope} from '@fortawesome/free-regular-svg-icons';
import RecommendationModal from './RecommendationModal';
import { Errors } from '../../../../partials/Partials';

function Navigation({setRecommendationSent}) {
    const [navigation_data, setNavigationData] = useState({});
    const {links, messages} = navigation_data || '';
    const [recommendation_modal, setRecommendationModal] = useState(false)
    const [errors, setErrors] = useState([]);

    let links_list = [];
    let new_list = ['Dodaj ogłoszenie o pracę', 'Certyfikaty i widgety', 'Poproś innego prawnika o rekomendację dla Ciebie'];

    useEffect(() => {
        fetch('/api/edit-menu-links/').then(res => {
            if (res.ok) {
            res.json().then(
                data => {
                    setErrors([])
                    setNavigationData(data)
                }
            )
            } else {
                setErrors(['Nie udało się pobrać menu'])
            }
        })
    },[])
    
    const pathname = window.location.pathname

    if (links) {
        links.forEach((link, index) => {
            const {href, text} = link || ''
            links_list.push(
                <div className="navigation-link" key={index} onClick={() => {
                    if (href === '#lawyer-rewiew') {
                        setRecommendationModal(true)
                    }
                }}>
                    <a href={href} style={{fontWeight: pathname === href ? '600' : '350'}}>
                        <div>
                            {text === 'Wiadomości' ?
                                <FontAwesomeIcon icon={faEnvelope}  className="envelope"/>
                            : null
                            }
                            {text}
                        </div>
                        {new_list.indexOf(text) !== -1 ? 
                            <div className="badge badge-success">NOWE</div>
                        : null
                        }
                        {text === 'Wiadomości' ? <span className="message">{messages}</span>
                        : null}
                    </a>
                </div>
            )
        })
    }


  return (
    <div id="navigation">
        <Errors errors={errors} />
        {links_list}
        <RecommendationModal show={recommendation_modal} setShow={setRecommendationModal} setRecommendationSent={setRecommendationSent}/>
    </div>
  )
}

export default Navigation